
function ProgramMap (){

    this.build();
    resizeCallbacks.push(this);
    barbaCallbacks.push(this);

}

ProgramMap.prototype.build = function(){

    this.init();
    this.sticky();

};

ProgramMap.prototype.sticky = function(){

    let isPin = document.querySelector('.archive-map-pin');

    if(isPin) {

        let triggerElement = document.querySelector('.listing-residence');

        this.mapPin = new ScrollMagic.Scene({
            triggerElement: triggerElement,
            triggerHook: 0,
            duration: triggerElement.offsetHeight - window.innerHeight
        })
        .setPin(isPin)
        .setClassToggle(".map-toggle", "visible")
        .addTo(scrollController);

    }

};

ProgramMap.prototype.init = function(){

    this.mapElement = document.getElementById('map');

    if( $("#map").length == 0 ){
        return false;
    }

    let program = {
        lat: $(this.mapElement).data('center-lat'),
        lng: $(this.mapElement).data('center-lng')
    };

    let markers = [];
    $('.map-utils').each(function(){
        markers.push({
            'content' : $(this).html(),
            'lat' : $(this).data('lat'),
            'lng' : $(this).data('lng'),
            'icon' : $(this).data('icon'),
            'link' : $(this).data('link')
        });
    });

    // The map, centered at program
    this.map = new google.maps.Map(
        this.mapElement,
        {
            zoom: 14,
            center: program,
            gestureHandling: 'cooperative',
            mapTypeControl: false,
            streetViewControl: false,
            fullscreenControl: false,
            zoomControl: false,
            styles:           [
                {"featureType": "administrative","elementType": "labels.text.fill","stylers": [{"color": "#444444"}]},
                {"featureType": "landscape","elementType": "all","stylers": [{"color": "#f2f2f2"}]},
                {"featureType": "poi","elementType": "all","stylers": [{"visibility": "off"}]},
                {"featureType": "road","elementType": "all","stylers": [{"saturation": -100},{"lightness": 45}]},
                {"featureType": "road.highway","elementType": "all","stylers": [{"visibility": "simplified"}]},
                {"featureType": "road.arterial","elementType": "labels.icon","stylers": [{"visibility": "off"}]},
                {"featureType": "transit","elementType": "all","stylers": [{"visibility": "off"}]},
                {"featureType": "water","elementType": "all","stylers": [{"color": "#a6d8d9"},{"visibility": "on"}]}
            ]
        }
    );
    this.addMarker( program, '', $(this.mapElement).data('pointer') );
    this.bounds = new google.maps.LatLngBounds();

    let that = this;

    $.each(markers, function(index, element){
        let marker = {
            lat: element.lat,
            lng: element.lng
        };
        that.addMarker( marker, element.content, element.icon, element.link );

        if( $(that.mapElement).data('bounds') && markers.length > 1 ){
            that.bounds.extend( marker );
            that.map.fitBounds(that.bounds);
        }
    });

    let toggle = document.querySelector('.map-toggle');
    if( toggle ) {
        toggle.addEventListener('click', () => {
            document.querySelector('.archive-map-pin').classList.add('active');
        });
        let close = document.querySelector('.map-close');
        close.addEventListener('click', () => {
            document.querySelector('.archive-map-pin').classList.remove('active');
        });
        let fullscreen = document.querySelector('.map-fullscreen');
        fullscreen.addEventListener('click', () => {
            document.querySelector('.archive-map').classList.toggle('fullscreen');
        });
    }

};

ProgramMap.prototype.addMarker = function(LatLng, content, icon, link){

    let image = new google.maps.MarkerImage(icon, null, null, null, new google.maps.Size(16, 20));

    let marker = new google.maps.Marker({
        position: LatLng,
        map: this.map,
        icon: image,
        zIndex : ( icon.search("nos-residences") > 0 ) ? 2 : 1
    });

    if( link ){
        marker.addListener('click', function() {
            window.location = link;
        });
    }

    if( content ) {
        let infowindow = new google.maps.InfoWindow({
            content: content
        });
        marker.addListener('mouseover', function () {
            infowindow.open(this.map, marker);
        });
        marker.addListener('mouseout', function () {
            infowindow.close();
        });
    }

};

ProgramMap.prototype.resize = function(){
    if( this.map ) {
        this.map.fitBounds(this.bounds);
    }
};
